export default __webpack_public_path__ + "media/images/del_16-6f86b7384ed9c9f571dd9ec33655d167.png";